// NEW_FILE_JUSTIFIED: Top-of-canvas banner shown after AI policy extraction (Task 11)
import { Sparkles, X } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';
import type { IAiExtractionBannerProps } from '@/@types/insuranceBuilder';

export function AiExtractionBanner({
  sectionCount,
  fieldCount,
  onDismiss,
}: IAiExtractionBannerProps) {
  return (
    <div
      role="status"
      className={cn('flex items-start gap-3 rounded-xl border border-primary/30 bg-primary/10 p-4')}
    >
      <Sparkles className="h-5 w-5 shrink-0 text-primary" aria-hidden="true" />
      <div className="flex-1">
        <p className="text-sm font-medium text-foreground">
          AI extracted {sectionCount} {sectionCount === 1 ? 'section' : 'sections'}, {fieldCount}{' '}
          {fieldCount === 1 ? 'field' : 'fields'}.
        </p>
        <p className="text-xs text-muted-foreground">Edit anything before saving.</p>
      </div>
      {onDismiss && (
        <Button
          type="button"
          variant="ghost"
          size="icon"
          aria-label="Dismiss AI extraction notice"
          onClick={onDismiss}
        >
          <X className="h-4 w-4" aria-hidden="true" />
        </Button>
      )}
    </div>
  );
}
